import React, { useState } from 'react';
import Styles from '../styles/components/NewSongForm.module.css';

const NewSongForm = ({ onSubmit }) => {
    const [formData, setFormData] = useState({
        title: '',
        type: '',
        ccli_number: '',
        notes: '',
        hymn_number: '',
        songwriter: '',
        has_slideshow: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.title || !formData.type) {
            alert('Title and Type are required.');
            return;
        }

        const cleanedData = {
            ...formData,
            has_slideshow:
                formData.has_slideshow === '' ? null : parseInt(formData.has_slideshow),
        };
        onSubmit(cleanedData);

        setFormData({
            title: '',
            type: '',
            ccli_number: '',
            notes: '',
            hymn_number: '',
            songwriter: ''
        });
    };

    return (
        <form className={Styles.formContainer} onSubmit={handleSubmit}>
            <div className={Styles.formGroup}>
                <label htmlFor="title">Title<span>*</span>:</label>
                <input
                    type="text"
                    id="title"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                />
            </div>

            <div className={Styles.formGroup}>
                <label>Type<span>*</span>:</label>
                <div className={Styles.radioGroup}>
                    <label>
                        <input
                            type="radio"
                            name="type"
                            value="hymn"
                            checked={formData.type === 'hymn'}
                            onChange={handleChange}
                        />
                        Hymn
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="type"
                            value="contemporary"
                            checked={formData.type === 'contemporary'}
                            onChange={handleChange}
                        />
                        Contemporary
                    </label>
                </div>
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="songwriter">Songwriter:</label>
                <input
                    type="text"
                    id="songwriter"
                    name="songwriter"
                    value={formData.songwriter}
                    onChange={handleChange}
                />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="ccli_number">CCLI Number:</label>
                <input
                    type="text"
                    id="ccli_number"
                    name="ccli_number"
                    value={formData.ccli_number}
                    onChange={handleChange}
                />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="hymn_number">Hymn Number:</label>
                <input
                    type="number"
                    id="hymn_number"
                    name="hymn_number"
                    value={formData.hymn_number}
                    onChange={handleChange}
                />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="has_slideshow">Slideshow Available:</label>
                <select
                    id="has_slideshow"
                    name="has_slideshow"
                    value={formData.has_slideshow}
                    onChange={handleChange}
                >
                    <option value="">Not specified</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="notes">Notes:</label>
                <textarea
                    id="notes"
                    name="notes"
                    rows="3"
                    value={formData.notes}
                    onChange={handleChange}
                />
            </div>

            <button type="submit" className={Styles.submitButton}>Add Song</button>
        </form>
    );
};

export default NewSongForm;
